interface TitleSectionEspaceProProps {
  title: string;
  }

export const TitleSectionEspacePro = ({title}: TitleSectionEspaceProProps) => {
  return (
      <h3 className={"font-playfair-display italic font-bold text-muted-foreground text-xl mb-8"}>{title}</h3>
  );
};

export const TitleSectionEspaceProLarge = ({title}: TitleSectionEspaceProProps) => {
  return (
      <h3 className={"font-playfair-display italic font-bold text-muted-foreground text-3xl mb-8"}>{title}</h3>
  );
}